// src/pages/AboutContact.js
import React, { useEffect, useState } from 'react';
import {
    Box,
    Container,
    Typography,
    CircularProgress,
    Card,
    CardMedia,
    CardContent,
} from '@mui/material';
import { supabase } from '../api/supabaseClient';
import { useTranslation } from 'react-i18next';
import Footer from '../components/Footer';

const AboutContact = () => {
    const { i18n } = useTranslation();
    const [aboutData, setAboutData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchAbout = async () => {
            setLoading(true);
            const { data, error: aboutErr } = await supabase
                .from('about')
                .select('*')
                .single();

            if (aboutErr) {
                console.error('Error fetching AboutContact:', aboutErr);
                setError('Could not load About data.');
            } else {
                setAboutData(data);
            }
            setLoading(false);
        };
        fetchAbout();
    }, []);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Container sx={{ mt: 4 }}>
                <Typography color="error" align="center">
                    {error}
                </Typography>
            </Container>
        );
    }

    if (!aboutData) {
        return null;
    }

    const { image_url, bio_en, bio_tr } = aboutData;
    const bioText = i18n.language === 'tr' ? bio_tr : bio_en;
    const titleText = i18n.language === 'tr' ? 'Hakkında' : 'About';

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 'calc(100vh - 64px)' }}>
            <Box component="main" sx={{ flexGrow: 1, py: 4 }}>
                <Container maxWidth="sm">
                    <Card sx={{ mx: 'auto', textAlign: 'center' }}>
                        {image_url && (
                            <CardMedia
                                component="img"
                                image={image_url}
                                alt="About"
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'cover',
                                }}
                            />
                        )}
                        <CardContent>
                            <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
                                {titleText}
                            </Typography>
                            <Typography
                                variant="body1"
                                color="text.secondary"
                                sx={{
                                    whiteSpace: 'pre-wrap',
                                    fontSize: '1.1rem',
                                    lineHeight: 1.7,
                                }}
                            >
                                {bioText}
                            </Typography>
                        </CardContent>
                    </Card>
                </Container>
            </Box>

            {/*<Box sx={{ mt: 'auto' }}>*/}
            {/*    <Footer data={aboutData} />*/}
            {/*</Box>*/}
        </Box>
    );
};

export default AboutContact;
